import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import React from "react";
import { useTranslation } from "react-i18next";

import { useLocatorContext } from "../LocatorContext/LocatorContext";
import style from "./style.module.scss";

interface Props {
    address?: string;
}

export const NoResultsOverlay = ({ address }: Props): JSX.Element => {
    const { t } = useTranslation();
    const { noResults } = useLocatorContext();

    return noResults ? (
        <div className={style.mapOverlay}>
            <Typography color="white" variant="label-01">
                {t("No results found for '{{LOCATION}}'. You can try another search criterion.", {
                    LOCATION: address,
                    ns: "common",
                })}
            </Typography>
        </div>
    ) : null;
};
